import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import classNames from "classnames";

import { Menubar } from "primereact/menubar";
import { Menu } from "primereact/menu";
import { OverlayPanel } from "primereact/overlaypanel";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Password } from "primereact/password";

import { AccountService } from "../service/AccountService";

import { BreadcrumbsService } from "./AppBreadCrumb";
import { ToastService } from "../AppToast";
import { AppConfig } from "./AppConfig";
import { ROLE } from "../Constant";
import { InputText } from "primereact/inputtext";
import { AppStorage } from "../service/UserStorage";
import { TenantCompanyService } from "./he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService";
import EventEmitter from "../utils/EventEmitter";
import { Checkbox } from "primereact/checkbox";
import cookie from "cookiejs";
import { useDialogExportContext } from "./context/DialogExportContext";

export const AppTopbar = (props) => {
  const { permissions } = props;
  const op = useRef(null);
  const menu = useRef(null);

  const location = useLocation();

  const [submitting, setSubmitting] = useState(false);

  const [displayChangePassword, setDisplayChangePassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [appUserMenus, setAppUserMenus] = useState([]);
  const [addressCompany, setAddressCompany] = useState("");
  const [useIdentityCard, setUseIdentityCard] = useState(false);
  const [identityCard, setIdentityCard] = useState("");
  const [displayUpdateAddress, setDisplayUpdateAddress] = useState(
    AppStorage.get(`${AppStorage.get("tenantName")}_notification`) === "true",
  );
  const { setStatus } = useDialogExportContext();
  const [tenantInfo, setTenantInfo] = useState(null);
  const template = (item, options) => {
    if (item.target) {
      return (
        <NavLink to={item.target} className={options.className}>
          <span className={options.iconClassName} />
          <span className={options.labelClassName}>{item.label}</span>
        </NavLink>
      );
    } else {
      return (
        <a
          href="/"
          className={options.className}
          target={item.target}
          onClick={options.onClick}
        >
          <span className={options.iconClassName} />
          <span className={options.labelClassName}>{item.label}</span>
        </a>
      );
    }
  };

  const appMenus: Array<any> = [
    {
      label: "Đăng ký phát hành",
      icon: "fa-solid fa-file-circle-check",
      className: "app-menu-20",
      items: [
        {
          label: "Mẫu hóa đơn",
          role: ROLE.REGISTER_INVOICE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/phat-hanh/mau-hoa-don",
          template,
        },
        {
          label: "Tờ khai đăng ký/thay đổi NĐ123/2020",
          role: ROLE.DECLARE_REGISTER_INVOICE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/phat-hanh/to-khai-dang-ky-nd123",
          template,
        },
        {
          label: "Tờ khai đăng ký/thay đổi NĐ70/2025-NĐ254/2026",
          role: ROLE.DECLARE_REGISTER_INVOICE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/phat-hanh/to-khai-dang-ky-nd70",
          template,
        },
      ],
    },
    {
      label: "Hoá đơn đầu ra",
      role: ROLE.INVOICE_MANAGEMENT,
      parentRole: true,
      icon: "fa-solid fa-file-invoice-dollar",
      target: "/hoa-don",
      template,
    },
    {
      label: "Xử lý sai sót",
      icon: "fa-solid fa-file-circle-exclamation",
      className: "app-menu-25",
      items: [
        {
          label: "Thông báo HĐ sai sót 04/SS-HĐĐT",
          role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_WRONG_INVOICE,
          icon: "pi pi-fw pi-circle",
          target: "/xu-ly-sai-sot/thong-bao-04-ss-hddt",
          template,
        },
        {
          label: "Thay thế hóa đơn",
          role: ROLE.ERROR_MANAGEMENT_INVOICE_SUBSTITUDE,
          icon: "pi pi-fw pi-circle",
          target: "/xu-ly-sai-sot/thay-the-hoa-don",
          template,
        },
        {
          label: "Điều chỉnh hóa đơn",
          role: ROLE.ERROR_MANAGEMENT_INVOICE_ADJUSTMENT,
          icon: "pi pi-fw pi-circle",
          target: "/xu-ly-sai-sot/dieu-chinh-hoa-don",
          template,
        },
        {
          label: "Thay thế HĐ trên hệ thống khác",
          role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_SUBSTITUDE,
          icon: "pi pi-fw pi-circle",
          target: "/xu-ly-sai-sot/thay-the-hoa-don-tren-he-thong-khac",
          template,
        },
        {
          label: "Điều chỉnh HĐ trên hệ thống khác",
          role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_ADJUSTMENT,
          icon: "pi pi-fw pi-circle",
          target: "/xu-ly-sai-sot/dieu-chinh-hoa-don-tren-he-thong-khac",
          template,
        },
        // {
        //   label: "Thay thế nhiều hóa đơn",
        //   role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_SUBSTITUDE,
        //   icon: "pi pi-fw pi-circle",
        //   target: "/xu-ly-sai-sot/thay-the-nhieu-hoa-don",
        //   template,
        // },
        // {
        //   label: "Điều chỉnh nhiều hóa đơn",
        //   role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_ADJUSTMENT,
        //   icon: "pi pi-fw pi-circle",
        //   target: "/xu-ly-sai-sot/dieu-chinh-nhieu-hoa-don",
        //   template,
        // },
        {
          label: "Hủy hóa đơn",
          role: ROLE.ERROR_MANAGEMENT_INVOICECANCEL,
          icon: "pi pi-fw pi-circle",
          target: "/xu-ly-sai-sot/huy-hoa-don",
          template,
        },
        {
          label: "Bảng kê",
          role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_WRONG_INVOICE,
          icon: "pi pi-fw pi-angle-down",
        },
        // {
        //   label: "Bảng kê điều chỉnh/thay thế",
        //   role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_WRONG_INVOICE,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/xu-ly-sai-sot/bang-ke",
        //   template,
        // },
        {
          label: "Bảng kê Hóa đơn chiết khấu",
          role: ROLE.ERROR_MANAGEMENT_OTHER_INVOICE_WRONG_INVOICE,
          icon: "pi pi-fw pi-minus",
          className: "pl-3",
          target: "/xu-ly-sai-sot/bang-ke-hoa-don-chiet-khau",
          template,
        },
      ],
    },
    {
      label: "Lịch sử truyền nhận",
      icon: "pi pi-sort-alt",
      className: "app-menu-20",
      items: [
        {
          label: "Tờ khai đăng ký",
          role: ROLE.MGATEWAY_DECLARE,
          icon: "pi pi-fw pi-circle",
          target: "/lich-su-truyen-nhan/to-khai-dang-ky",
          template,
        },
        {
          label: "Hóa đơn",
          role: ROLE.MGATEWAY_INVOICE,
          icon: "pi pi-fw pi-circle",
          target: "/lich-su-truyen-nhan/hoa-don",
          template,
        },
        {
          label: "Thông báo sai sót",
          role: ROLE.MGATEWAY_WRONG_INVOICE,
          icon: "pi pi-fw pi-circle",
          target: "/lich-su-truyen-nhan/thong-bao-sai-sot",
          template,
        },
        {
          label: "Bảng tổng hợp",
          role: ROLE.MGATEWAY_INVOICE_SUMMARY,
          icon: "pi pi-fw pi-circle",
          target: "/lich-su-truyen-nhan/bang-tong-hop",
          template,
        },
        // {
        //   label: "Lịch sử thanh toán QRCode",
        //   role: ROLE.MGATEWAY_INVOICE_SUMMARY,
        //   icon: "pi pi-fw pi-circle",
        //   target: "/lich-su-truyen-nhan/lich-su-thanh-toan",
        //   template,
        // },
      ],
    },
    {
      label: "Báo cáo",
      icon: "pi pi-fw pi-chart-line",
      className: "app-menu-25",
      items: [
        {
          label: "Báo cáo tình hình sử dụng hóa đơn",
          role: ROLE.REPORT_SUMMARY,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/tinh-hinh-su-dung",
          template,
        },
        {
          label: "Báo cáo tổng hợp hóa đơn",
          role: ROLE.REPORT_SUMMARY,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/tong-hop-hoa-don",
          template,
        },
        {
          label: "Báo cáo chi tiết hóa đơn",
          role: ROLE.REPORT_DETAIL,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/chi-tiet-hoa-don",
          template,
        },
        {
          label: "Báo cáo nhận vào PMKT",
          role: ROLE.REPORT_PMKT,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/nhan-pmkt",
          template,
        },
        {
          label: "Báo cáo PL101/2023/QH15",
          role: ROLE.REPORT_PLQH,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/pl43-2022-qh15",
          template,
        },
        {
          label: "Báo cáo bảng kê bán ra (PL01)",
          role: ROLE.REPORT_PLQH01,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/phu-luc-01",
          template,
        },
        // { label: 'Lập bảng tổng hợp mẫu 01/TH-HĐĐT', role: ROLE.REPORT_SUMMARY01, icon: 'pi pi-fw pi-circle', target: '/bao-cao/tong-hop-mau-01', template },
        {
          label: "Kiểm tra trạng thái MST",
          role: ROLE.INVOICE_MANAGEMENT,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/trang-thai-mst",
          template,
        },
        {
          label: "Báo cáo xăng dầu mẫu thuế",
          role: ROLE.REPORT_SUMMARY,
          icon: "pi pi-fw pi-circle",
          target: "/bao-cao/tong-hop-hoa-don-xang-dau",
          template,
        },
        {
          label: "Lập bảng tổng hợp mẫu 01/TH-HĐĐT",
          icon: "pi pi-fw pi-circle",
          role: ROLE.REPORT_SUMMARY,
          target: "/bao-cao/bang-tong-hop",
          template,
        },
      ],
    },
    {
      label: "Danh mục",
      icon: "pi pi-fw pi-th-large",
      className: "app-menu-20",
      items: [
        {
          label: "Khách hàng ",
          role: ROLE.CATEGORY_TENANT_CLIENT,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/khach-hang",
          template,
        },
        {
          label: "Hàng hóa, dịch vụ",
          role: ROLE.CATEGORY_PRODUCT,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/hang-hoa-dich-vu",
          template,
        },
        {
          label: "Đơn vị tính",
          role: ROLE.CATEGORY_UNIT,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/don-vi-tinh",
          template,
        },
        {
          label: "Tiền tệ",
          role: ROLE.CATEGORY_CURRENCY,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/tien-te",
          template,
        },
        {
          label: "Mẫu Email",
          role: ROLE.CATEGORY_EMAIL_TEMPLATE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/mau-email",
          template,
        },
        {
          label: "Thuế suất",
          role: ROLE.CATEGORY_TAX,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/thue-suat",
          template,
        },
        {
          label: "Hình thức thanh toán",
          role: ROLE.CATEGORY_PAYMENT_TYPE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/ht-thanh-toan",
          template,
        },
        // {
        //   label: "Ngân hàng",
        //   role: ROLE.CATEGORY_PAYMENT_TYPE,
        //   parentRole: true,
        //   icon: "pi pi-fw pi-circle",
        //   target: "/danh-muc/ngan-hang-thu-huong",
        //   template,
        // },
        {
          label: "Địa điểm kinh doanh",
          role: ROLE.CATEGORY_UNIT,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/danh-muc/dia-diem-kinh-doanh",
          template,
        },
        // {
        //   label: "Quản lý xăng dầu",
        //   role: [ROLE.CATEGORY_PRODUCT, ROLE.CATEGORY_TENANT_CLIENT],
        //   icon: "pi pi-fw pi-angle-down",
        // },
        // {
        //   label: "Cửa hàng xăng dầu",
        //   role: ROLE.CATEGORY_PRODUCT,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/danh-muc/cua-hang-xang-dau",
        //   template,
        // },
        // {
        //   label: "Mặt hàng xăng dầu",
        //   role: ROLE.CATEGORY_PRODUCT,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/danh-muc/hang-hoa-xang-dau",
        //   template,
        // },
        // {
        //   label: "Vòi bơm",
        //   role: ROLE.CATEGORY_PRODUCT,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/danh-muc/thiet-bi",
        //   template,
        // },
        // {
        //   label: "Danh mục thiết bị tích hợp",
        //   role: ROLE.CATEGORY_PRODUCT,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/danh-muc/thiet-bi-tich-hop",
        //   template,
        // },
        // {
        //   label: "Danh sách giao dịch xăng dầu",
        //   role: ROLE.CATEGORY_PRODUCT,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/danh-muc/danh-sach-giao-dich-xang-dau",
        //   template,
        // },
        // {
        //   label: "Cấu hình tạo hóa đơn xăng dầu",
        //   role: ROLE.SYSTEM_EMAILING,
        //   icon: "pi pi-fw pi-minus",
        //   className: "pl-3",
        //   target: "/he-thong/cau-hinh-dong-bo-hoa-don-xang-dau",
        //   template,
        // },
      ],
    },
    {
      label: "Cấu hình",
      icon: "pi pi-fw pi-cog",
      className: "app-menu-20",
      items: [
        {
          label: "Nhóm quyền",
          role: ROLE.USER_MANAGEMENT_SYSTEM_ROLES,
          icon: "pi pi-fw pi-circle",
          target: "/cau-hinh/nhom-quyen",
          template,
        },
      ],
    },
    {
      label: "Hệ thống",
      icon: "pi pi-fw pi-cog",
      className: "app-menu-20",
      items: [
        {
          label: "Quản lý doanh nghiệp",
          role: [ROLE.COMPANY_MANAGEMENT_INFO, ROLE.COMPANY_MANAGEMENT_LICENSE],
          icon: "pi pi-fw pi-angle-down",
        },
        {
          label: "Thông tin doanh nghiệp",
          role: ROLE.COMPANY_MANAGEMENT_INFO,
          icon: "pi pi-fw pi-minus",
          className: "pl-3",
          target: "/he-thong/doanh-nghiep/thong-tin-doanh-nghiep",
          template,
        },
        {
          label: "Bản quyền",
          role: ROLE.COMPANY_MANAGEMENT_LICENSE,
          icon: "pi pi-fw pi-minus",
          className: "pl-3",
          target: "/he-thong/doanh-nghiep/ban-quyen",
          template,
        },
        {
          label: "Quản lý người dùng",
          role: [ROLE.USER_MANAGEMENT_ROLES, ROLE.USER_MANAGEMENT_USERS],
          icon: "pi pi-fw pi-angle-down",
        },
        {
          label: "Nhóm quyền",
          role: ROLE.USER_MANAGEMENT_ROLES,
          icon: "pi pi-fw pi-minus",
          className: "pl-3",
          target: "/he-thong/nguoi-dung/nhom-quyen",
          template,
        },
        {
          label: "Người sử dụng",
          role: ROLE.USER_MANAGEMENT_USERS,
          icon: "pi pi-fw pi-minus",
          className: "pl-3",
          target: "/he-thong/nguoi-dung/nguoi-su-dung",
          template,
        },
        {
          label: "Đăng ký chứng thư số",
          role: ROLE.SYSTEM_TOKEN_MANAGEMENT,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/he-thong/chung-thu-so",
          template,
        },
        {
          label: "Khai báo tham số hệ thống",
          role: ROLE.SYSTEM_TENANT_SETTING,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/he-thong/tham-so-he-thong",
          template,
        },
        {
          label: "Cấu hình hoá đơn",
          role: ROLE.SYSTEM_CONFIG_INVOICE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/he-thong/cau-hinh-hoa-don",
          template,
        },
        {
          label: "Cấu hình email server",
          role: ROLE.SYSTEM_EMAILING,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/he-thong/cau-hinh-email-server",
          template,
        },
        {
          label: "Giá trị thay thế",
          role: ROLE.SYSTEM_VALUE_REPLACES,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/he-thong/gia-tri-thay-the",
          template,
        },
        {
          label: "Giá trị mặc định",
          role: ROLE.SYSTEM_VALUE_DEFAULT,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/he-thong/gia-tri-mac-dinh",
          template,
        },
        {
          label: "Quản trị - Quản lý mẫu hóa đơn",
          role: ROLE.SYSTEM_INVOICE_TEMPLATE,
          parentRole: true,
          icon: "pi pi-fw pi-circle",
          target: "/admin/mau-hoa-don",
          template,
        },
        // {label: 'Cấu hình email TB MTT cần ký', role: ROLE.SYSTEM_EMAILING, parentRole: true, icon: 'pi pi-fw pi-circle', target: '/he-thong/cau-hinh-email-tb-mtt', template},
      ],
    },
  ];

  const logout = () => {
    console.log(1);
    setStatus("success");
    localStorage.removeItem("jobIdRunning");
    cookie.remove("access_token_report");
    cookie.remove("refresh_token_report");
    cookie.remove("refreshExpiredAt");
    window.location.hash = "/login";
  };

  const accountMenus = [
    { label: props.user.name, icon: "pi pi-fw pi-user" },
    {
      label: "Đổi mật khẩu",
      icon: "pi pi-fw pi-key",
      command: () => {
        setDisplayChangePassword(true);
        cookie.remove("access_token_report");
        cookie.remove("refresh_token_report");
      },
    },
    { separator: true },
    { label: "Đăng xuất", icon: "pi pi-fw pi-sign-out", command: logout },
  ];

  const setMenuDescriptionRecursive = (menu) => {
    menu.recursiveLabels.push(menu);
    if (menu.items) {
      menu.items.forEach((item) => {
        item.recursiveLabels = [...menu.recursiveLabels];
        setMenuDescriptionRecursive(item);
      });
    }
  };

  const getMenuDescriptionRecursive = (pathname, menu) => {
    let recursiveLabels;
    if (pathname === menu.target) {
      recursiveLabels = menu.recursiveLabels;
    } else if (
      pathname === `${menu.target}/create` ||
      pathname.includes(`${menu.target}/create/`)
    ) {
      recursiveLabels = menu.recursiveLabels;
      recursiveLabels.push({ label: "Tạo mới" });
    } else if (pathname.includes(`${menu.target}/detail/`)) {
      recursiveLabels = menu.recursiveLabels;
      recursiveLabels.push({ label: "Chi tiết" });
    } else if (pathname.includes(`${menu.target}/update/`)) {
      recursiveLabels = menu.recursiveLabels;
      recursiveLabels.push({ label: "Chỉnh sửa" });
    }

    if (!recursiveLabels && menu.items) {
      for (const item of menu.items) {
        recursiveLabels = getMenuDescriptionRecursive(pathname, item);
        if (recursiveLabels) {
          break;
        }
      }
    }
    return recursiveLabels;
  };

  const getMenuDescription = (menus) => {
    let recursiveLabels;
    for (const menu of menus) {
      recursiveLabels = getMenuDescriptionRecursive(location.pathname, menu);
      if (recursiveLabels) {
        break;
      }
    }
    if (recursiveLabels) {
      const breadcrumbs = [];
      recursiveLabels.forEach(({ label, target }) => {
        const breadcrumb: any = { label };
        if (target) {
          breadcrumb.command = () => {
            window.location.hash = target;
          };
        }
        breadcrumbs.push(breadcrumb);
      });
      BreadcrumbsService.setBreadcrumbs(breadcrumbs);
    }
  };

  const recurGenMenu = async (curNode, menu) => {
    if (!menu.items || menu.items.length == 0) {
      if (curNode.role) {
        if (Array.isArray(curNode.role)) {
          for (const role of curNode.role) {
            if (
              (permissions.indexOf(role) >= 0 && !curNode.parentRole) ||
              (permissions.filter((t) => t.includes(role)).length &&
                curNode.parentRole)
            ) {
              return curNode;
            }
          }
        } else {
          if (
            (permissions.indexOf(curNode.role) >= 0 && !curNode.parentRole) ||
            (permissions.filter((t) => t.includes(curNode.role)).length &&
              curNode.parentRole)
          ) {
            return curNode;
          }
        }
      }
      return null;
    } else {
      curNode.items = [];
      for (let i = 0; i < menu.items.length; i++) {
        let nextNode = JSON.parse(JSON.stringify(menu.items[i]));
        nextNode.template = menu.items[i].template;
        let child = await recurGenMenu(nextNode, menu.items[i]);
        if (child) {
          curNode.items.push(child);
        }
      }
      return curNode.items.length > 0 ? curNode : null;
    }
  };

  useEffect(() => {
    new Promise((resolve) => {
      let data = { items: appMenus };
      let clearMenu = [];
      let menu = recurGenMenu(clearMenu, data);
      resolve(menu);
    }).then((data: any) => {
      let menu = data && data.items ? data.items : [];
      menu.forEach((m) => {
        m.recursiveLabels = [];
        setMenuDescriptionRecursive(m);
      });
      setAppUserMenus(menu);
      getMenuDescription(menu);
    });
  }, [permissions, location]);

  const downloadPlugin = () => {
    const link = document.createElement("a");
    link.href = `assets/tool/setup.exe`;
    link.click();

    const linkHelp = document.createElement("a");
    linkHelp.href = `#`;
    linkHelp.target = "_blank";
    linkHelp.click();
  };
  const changePassword = (event) => {
    if (!submitting) {
      setSubmitting(true);

      if (newPassword?.includes(" ")) {
        ToastService.error("Mật khẩu không hợp lệ!");
        setSubmitting(false);
      } else if (newPassword === newPasswordConfirm) {
        AccountService.changePassword({
          currentPassword,
          newPassword,
          newPasswordConfirm,
        })
          .then(() => {
            setDisplayChangePassword(false);
            ToastService.success();
            logout();
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        ToastService.error("Mật khẩu nhập lại không chính xác");
        setSubmitting(false);
      }
    }
    event.preventDefault();
  };

  const updateAddress = (event) => {
    event.preventDefault();
    const tenant = AppStorage.get("tenant");
    const tenantName = AppStorage.get("tenantName");
    const validateCCCD = (value) => {
      const cccdRegex = /^[0-9]{3}[0-5]\d{2}\d{6}$/;
      return cccdRegex.test(value);
    };
    if (useIdentityCard && !validateCCCD(identityCard)) {
      return ToastService.error("Căn cước công dân không hợp lệ");
    }
    TenantCompanyService.update(tenant, {
      ...tenantInfo,
      address: addressCompany,
      useIdentityCard: useIdentityCard,
      identityCard: useIdentityCard ? identityCard : "",
    }).then((res) => {
      const merged = { ...tenantInfo, ...res, address: addressCompany };
      AppStorage.set(
        "isHouseholdBusiness",
        merged.isHouseholdBusiness === true ? "true" : "false",
      );
      AppStorage.set("tenantInfo", JSON.stringify(merged));
      EventEmitter.emit("changeTenantInfo", merged);
      AppStorage.set(`${tenantName}_notification`, "false");
      setDisplayUpdateAddress(false);
      ToastService.success();
    });
  };

  useEffect(() => {
    const tenantInfo = AppStorage.get("tenant");
    TenantCompanyService.get(tenantInfo).then((res) => {
      AppStorage.set(
        "isHouseholdBusiness",
        res.isHouseholdBusiness === true ? "true" : "false",
      );
      AppStorage.set("tenantInfo", JSON.stringify(res));
      EventEmitter.emit("changeTenantInfo", res);
      setTenantInfo(res);
      setAddressCompany(res?.address);
    });
  }, []);

  return (
    <div className="layout-topbar">
      <Link to="/" className="layout-topbar-logo">
        <img src={"assets/layout/images/LogoAppMinvoice_new.png"} alt="logo" />
      </Link>

      <Menubar model={appUserMenus} className="app-menu" />
      <ul className={classNames("layout-topbar-menu lg:flex origin-top")}>
        <li>
          <a
            href={
              "#"
            }
            rel="noreferrer"
            target="_blank"
          >
            <button className="p-link layout-topbar-button">
              <i className="pi pi-youtube" />
              <span>Guide</span>
            </button>
          </a>
        </li>
        <li>
          <button
            className="p-link layout-topbar-button"
            onClick={downloadPlugin}
          >
            <i className="pi pi-download" title="Tải WIINVOICE Plugin" />
            <span>Download</span>
          </button>
        </li>
        <li>
          <button
            className="p-link layout-topbar-button"
            onClick={(e) => op.current.toggle(e)}
          >
            <i className="pi pi-bell" />
            <span>Notifications</span>
          </button>
          {/* <OverlayPanel ref={op} style={{ width: "450px" }}>
            <div className="grid notification">
              <div className="col-3">
                <div className="notification-icon">
                  <i className="fa-solid fa-bullhorn"></i>
                </div>
              </div>
              <div className="col-9">
                <p>
                  <b>
                    Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số
                    04
                  </b>
                </p>
                <p>02/06/2022</p>
              </div>
            </div>
            <div className="grid notification mt-2">
              <div className="col-3">
                <div className="notification-icon">
                  <i className="fa-solid fa-bullhorn"></i>
                </div>
              </div>
              <div className="col-9">
                <p>
                  <b>
                    Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số
                    04
                  </b>
                </p>
                <p>02/06/2022</p>
              </div>
            </div>
            <div className="grid notification mt-2">
              <div className="col-3">
                <div className="notification-icon">
                  <i className="fa-solid fa-bullhorn"></i>
                </div>
              </div>
              <div className="col-9">
                <p>
                  <b>
                    Kính mời quý khách hàng đọc ấn phẩm Thông tin chuyển đổi số
                    04
                  </b>
                </p>
                <p>02/06/2022</p>
              </div>
            </div>
          </OverlayPanel> */}
        </li>
        <li style={{ display: "none" }}>
          <AppConfig {...props} />
        </li>
        <li>
          <button
            className="p-link layout-topbar-button"
            onClick={(event) => menu.current.toggle(event)}
          >
            <i className="pi pi-user" />
            <span>Profile</span>
          </button>
          <Menu model={accountMenus} popup ref={menu} />
        </li>
      </ul>
      <Dialog
        header="Đổi mật khẩu"
        visible={displayChangePassword}
        style={{ width: "500px" }}
        position="top"
        onHide={() => setDisplayChangePassword(false)}
      >
        <form onSubmit={changePassword}>
          <div className="p-fluid formgrid grid">
            <div className="field col-12 md:col-12">
              <label htmlFor="currentPassword">Mật khẩu hiện tại</label>
              <Password
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                toggleMask
                feedback={false}
                required
              />
            </div>
            <div className="field col-12 md:col-12">
              <label htmlFor="newPassword">Mật khẩu mới</label>
              <Password
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                toggleMask
                required
              />
            </div>
            <div className="field col-12 md:col-12">
              <label htmlFor="newPasswordConfirm">Xác nhận mật khẩu mới</label>
              <Password
                value={newPasswordConfirm}
                onChange={(e) => setNewPasswordConfirm(e.target.value)}
                toggleMask
                feedback={false}
                required
              />
            </div>
          </div>

          <div className="flex justify-content-end mt-2">
            <Button
              label="Đổi mật khẩu"
              icon="pi pi-check"
              className="p-button-sm"
              loading={submitting}
            />
          </div>
        </form>
      </Dialog>
      {/* <Dialog
        header={
          <div>
            <p className='text-center'>THÔNG BÁO</p>
            <p className='text-center text-red-500'>V/v Cập nhật thông tin địa chỉ theo theo thay đổi địa giới hành chính</p>
          </div>
        }
        visible={displayUpdateAddress}
        style={{ width: '800px' }}
        position="top"
        onHide={() => setDisplayUpdateAddress(false)}
      >
        <p>Kính gửi Quý khách hàng,</p>
        <p>Cảm ơn Quý khách đã sử dụng dịch vụ Hỏa đơn điện tử Minvoice.</p>
        <p>Theo Nghị quyết số 60-NQ/TW, việc tổ chức chính quyền địa phương theo mô hình hai cấp (Tỉnh/Thành phổ và Xã/Phường) sẽ <b>được áp
          dụng từ ngày 01/07/2025</b></p>
        <p>Để phát hành hóa đơn theo địa chỉ mới Quý khách cần cập nhật lại thông tin địa chỉ dưới đây. Việc cập nhật địa chỉ đơn vị theo <b>thay
          đổi địa giới hành chính không cần lập và gửi tờ khai thay đổi thông tin sử dụng hóa đơn điện từ đến Cơ quan Thuế</b></p>
        <form onSubmit={updateAddress}>
          <div className="p-fluid formgrid grid">
            <div className="field col-12 md:col-12">
              <label htmlFor="currentPassword">Địa chỉ đơn vị bán<span className='text-red-500'>*</span></label>
              <InputText value={addressCompany} onChange={(e) => setAddressCompany(e.target.value)} required />
            </div>
            <b className='mb-3'>Theo Thông tư 86/2024/TT-BTC, Trường hợp người bán là Hộ, Cá nhân kinh doanh sử dụng CCCD thay cho Mã số thuế bên bán thì tích chọn tham số dưới đây</b>
            <div className="field col-12 md:col-12 flex align-items-center gap-2">
              <Checkbox checked={useIdentityCard} onChange={(e) => setUseIdentityCard(e.checked)} />
              <label htmlFor="currentPassword" className='m-0'>Hộ kinh doanh sử dụng căn cược công dân thay cho mã số thuế bên bán</label>
            </div>
            {useIdentityCard && (
              <div className="field col-6 md:col-6">
                <label htmlFor="currentPassword">Căn cước công dân<span className='text-red-500'>*</span></label>
                <InputText tooltip="Căn cước công dân" value={identityCard} onChange={(e) => setIdentityCard(e.target.value)} maxLength={12} required />
              </div>
            )}
          </div>

          <div className="flex justify-content-end mt-2">
            <Button label="Cập nhật" icon="pi pi-check" className="p-button-sm" loading={submitting} />
          </div>
        </form>
      </Dialog> */}
    </div>
  );
};
